import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[nimbusMaterialButtonsRow]',
  standalone: false,
})
export class NimbusMaterialButtonsRowDirective implements OnInit {
  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'nimbus-material-buttons-row');
  }
}
